<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaProdus')}} </h4>
        </div>
        <form class="add-user-form" id="add-product">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                        <div class="selections-option" v-if="input_field.inputName === 'nivel1'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel1')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_category" @input="getSubcategoriesFromCategory()" :options="categories" @change="calculateFinalPrice('category')" label="name"></v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName === 'nivel2'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel2')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_subcategory"  @input="getSubcategoriesSubtypes()" :options="subcategories" @change="calculateFinalPrice('subcategory')" label="name"></v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName === 'nivel3'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel3')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_subtype" :options="subtypes" @change="calculateFinalPrice('subtype')" label="name"></v-select>
                        </div>
                        <div v-else>
                            <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :data-vv-as="input_field.labelName"
                                   v-bind:name="input_field.inputName"
                                   v-bind:id="input_field.inputName"
                                   @input="calculateFinalPrice(input_field.inputName)"
                                   @change="calculateFinalPrice(input_field.inputName)">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                             <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                        </div>
                    </div>
                    <div class="form-group"
                         v-for="priceCat in priceCategoryes"
                         :key="priceCat.value">
                          <input type="text" class="form-control"
                                 placeholder=""
                                 v-validate="priceCat.validationRules"
                                 :data-vv-as="priceCat.display"
                                 v-bind:name="priceCat.addition"
                                 v-bind:id="priceCat.addition"
                                 @input="calculateFinalPrice('addition_inputs')"
                                 @change="calculateFinalPrice('addition_inputs')">
                          <label class=""> Adaos {{priceCat.display}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                              <i class="fas fa-percentage"></i>
                          </span>
                           <p class="custom-error-info"> {{errors.first(priceCat.addition)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                  <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                    <input type="text"
                          class="form-control"
                          placeholder=""
                          v-validate="input_field.validationRules"
                          :data-vv-as="input_field.labelName"
                          :name="input_field.inputName"
                          :id="input_field.inputName"
                          @input="calculateFinalPrice(input_field.inputName)"
                          @change="calculateFinalPrice(input_field.inputName)">
                    <label class=""> {{input_field.labelName}} </label>
                    <span class="focus-input"></span>
                    <span class="symbol-input">
                      <i v-bind:class="input_field.icon"></i>
                    </span>
                    <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                  </div>
                  <div class="form-group"
                       v-for="priceCat in priceCategoryes"
                       :key="priceCat.value">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="priceCat.validationRules"
                               :data-vv-as="priceCat.display"
                               v-bind:name="priceCat.name"
                               v-bind:id="priceCat.name"
                               @input="calculateFinalPrice('price_inputs')"
                               @change="calculateFinalPrice('price_inputs')">
                        <label class=""> Pret {{priceCat.display}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i class="fas fa-tags"></i>
                        </span>
                         <p class="custom-error-info"> {{errors.first(priceCat.name)}} </p>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group">
                      <div class="selections-option">
                        <v-select :options="manufacturers" v-model="manufacturer" label="name" placeholder="Alege Producator">
                        </v-select>
                      </div>
                    </div>
                    <div class="form-group">
                      <p class="trigger-add-prod" v-b-toggle.add-new-manufacturer variant="primary" @click="showManufacturer = !showManufacturer">
                        <i :class="showManufacturer === false ? 'fas fa-plus-circle' : 'fas fa-minus-circle'"></i>
                        Adauga Producator
                      </p>
                      <b-collapse id="add-new-manufacturer" class="template-add-prod">
                        <b-card>
                          <div class="form-group">
                            <input name="manufacturer" v-model="new_manufacturer">
                            <label class=""> Producator </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i class="fas fa-user-tag"></i>
                            </span>
                          </div>
                        </b-card>
                      </b-collapse>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-12">
                  <div class="doc-group">
                    <div class="template-section-heading">
                        <h4> Incarca imagini </h4>
                    </div>
                      <b-form-file
                              @change="onFileChange"
                              name="files[]"
                              v-model="file"
                              ref="file-input"
                              :state="Boolean(file)"
                              :placeholder="$t('placeholder.dropFilesHere')"
                              :drop-placeholder="$t('placeholder.dropFilesHere')"
                              multiple
                      ></b-form-file>
                       <div class="template-img-wrapper" v-if="url.img.length">
                         <div class="template-img-preview" v-for="(img, index) in url.img" :key="index">
                           <img :src="img" alt="product-image">
                           <div @click="removeMedia(index)" class="remove-product-image">
                             <i class="fas fa-times"></i>
                           </div>
                         </div>
                         <!--<div class="reset-files-wrapper">
                             <b-button @click="clearFiles" class="reset-files-button"> {{$t('txt.eliminaFisiereleIncarcate')}}
                             </b-button>
                         </div>-->
                       </div>
                  </div>
                </div>
                <div class="col-12">
                    <div class="template-section-heading">
                        <h4> Descriere produs </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea name='description'></textarea>
                        <div class="save-contact-buttons">
                            <button @click.prevent='addProduct()' :disabled="this.$store.state.loading">
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Level2Service from '../../api-services/nivel2.service.js'
import Level1Service from '../../api-services/nivel1.service.js'
import ProductsService from '../../api-services/products.service.js'

export default {
  name: 'AddProduct',
  data () {
    return {
      url: {
        img: [ ]
      },
      file: null,
      category: [],
      priceCategoryes: null,
      categories: [],
      subcategories: [],
      subtypes: [],
      select_category: null,
      select_subcategory: null,
      select_subtype: null,
      selected_label: null,
      input_fields: {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.products) ? this.products.ord : null,
            icon: 'fas fa-sort-numeric-up'
          },
          {
            inputName: 'nivel1',
            labelName: this.$t('placeholder.categorie'),
            inputValue: (this.products && this.products.nivel1) ? this.products.nivel1.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'nivel2',
            labelName: this.$t('placeholder.subcategorie'),
            inputValue: (this.products && this.products.nivel2) ? this.products.nivel2.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'nivel3',
            labelName: this.$t('placeholder.subtip'),
            inputValue: (this.products && this.products.nivel3) ? this.products.nivel3.name : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.products) ? this.products.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'stoc',
            labelName: this.$t('placeholder.stoc'),
            inputValue: (this.products) ? this.products.stoc : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'cost_acquisition',
            labelName: this.$t('placeholder.costAchizitie'),
            inputValue: (this.products) ? this.products.cost_acquisition : null,
            icon: 'fas fa-file-signature',
            model: ''
          },
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.products) ? this.products.discount : null,
            icon: 'fas fa-money-bill-wave info-tool',
            model: 'discount'
          }
        ]
      },
      manufacturer: null,
      new_manufacturer: null,
      manufacturers: [],
      showManufacturer: false
    }
  },
  methods: {
    removeMedia (index) {
      this.$delete(this.url.img, index)
      let target = document.querySelector('.custom-file-label')
      let targetText = target.innerHTML
      let parts = targetText.split(',')
      parts.splice(index, 1)
      let outputText = ''
      if (parts.length === 1) {
        outputText = parts.join('')
      } else {
        outputText = parts.join(',')
      }
      target.innerHTML = outputText
    },
    onFileChange (e) {
      const file = e.target.files
      let vm = this
      for (let i = 0; i < file.length; i++) {
        vm.url.img.push(URL.createObjectURL(file[i]))
      }
    },
    clearFiles () {
      this.$refs['file-input'].reset()
      this.url.img = []
    },
    calculateFinalPrice (target) {
      let fields = ['addition_inputs', 'category', 'subcategory', 'subtype', 'cost_acquisition']
      if (fields.includes(target)) {
        let costAcquisition = parseFloat(document.getElementsByName('cost_acquisition')[0].value)
        costAcquisition = costAcquisition > 0 ? costAcquisition : 0

        let vm = this
        this.priceCategoryes.forEach(function (priceCat) {
          let priceCatDOM = document.getElementsByName(priceCat.name)[0]
          let priceCatAddition = vm.getAddition(priceCat.addition)
          priceCatDOM.value = parseFloat(costAcquisition + ((priceCatAddition / 100) * costAcquisition))
          priceCatDOM.value = priceCatDOM.value > 0 ? priceCatDOM.value : 0
        })
      }
    },
    getAddition (param) {
      let output = parseFloat(document.getElementsByName(param)[0].value)
      if (output >= 0 && output != null) {
        output = output > 0 ? output : 0
        return output
      }

      if (this.select_subtype) {
        if (this.select_subtype[param] >= 0) {
          return this.select_subtype[param]
        }
      }
      if (this.select_subcategory) {
        if (this.select_subcategory[param] >= 0) {
          return this.select_subcategory[param]
        }
      }
      if (this.select_category) {
        if (this.select_category[param] >= 0) {
          return this.select_category[param]
        }
      }
      return 0
    },
    getSubcategoriesSubtypes () {
      let subcategoryId = (this.select_subcategory) ? this.select_subcategory.id : null
      this.subtypes = []
      if (subcategoryId > 0) {
        Level2Service.get(subcategoryId)
          .then((response) => {
            this.subtypes = response.data.data.nivel3
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getSubcategoriesFromCategory () {
      let categoryId = (this.select_category) ? this.select_category.id : null
      this.subcategories = []
      if (categoryId > 0) {
        Level1Service.get(categoryId)
          .then((response) => {
            this.subcategories = response.data.data.nivel2
            this.getSubcategoriesSubtypes()
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    addProduct () {
      if (!this.manufacturer && this.new_manufacturer === null) {
        this.$notify({
          group: 'error',
          type: 'error',
          text: 'Alege Producatorul!',
          'animation-type': 'css'
        })
        return false
      }
      let formData = new FormData(document.getElementById('add-product'))

      if (this.manufacturer && this.new_manufacturer === null) {
        formData.append('manufacturer', this.manufacturer.id)
      } else {
        formData.append('manufacturer', this.new_manufacturer)
      }
      if (this.select_category) {
        formData.append('nivel1', this.select_category.id)
      }
      if (this.select_subcategory) {
        formData.append('nivel2', this.select_subcategory.id)
      }
      if (this.select_subtype) {
        formData.append('nivel3', this.select_subtype.id)
      }
      ProductsService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.produsAdaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push('/products')
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    getCategories () {
      Level1Service.getAll().then((response) => {
        this.categories = response.data.data
        this.$store.dispatch('hideLoading')
        this.getSubcategoriesFromCategory()
      })
    },
    getManufacturers () {
      ProductsService.getManufacturers()
        .then((response) => {
          this.manufacturers = response.data.data.data
        })
        .catch((error) => {
          console.log(error)
          this.getManufacturers()
        })
    }
  },
  computed: {},
  created () {
    this.priceCategoryes = ProductsService.getPriceCategories()
    this.getCategories()
    this.getManufacturers()
    this.$store.dispatch('hideLoading')
  }
}
</script>
